<template>
  <transition name="fade">
    <div class="data-table-cost-popup" :class="referrer == 'history' ? 'bottom history' : 'top option'" v-show="option_modal">
      <div class="inbox-phrase-popup-title">メッセージの送信間隔</div>
      <div style="color:#aaa; font-size:10px" v-if="referrer == 'newmessage'">
        メッセージ送信間隔を変更できます。 通常、スパムとみなされないように6~8分の間隔を空けて送信しますが、お急ぎの場合は間隔を短縮することができます。
      </div>
      <div class="inbox-phrase-popup-radio-wrap">
        <div class="inbox-phrase-popup-radio left">
          <el-radio v-model="send_option.span" label="speedy" @change="speedyAlert()">スピーディ</el-radio>
          <el-tooltip placement="bottom-start">
            <div slot="content">2~3分程度の間隔でメッセージが送信されます。スパムとみなされる可能性が高くなります。</div>
            <span>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: -5px;" />
            </span>
          </el-tooltip>
        </div>
        <div class="inbox-phrase-popup-radio">
          <el-radio v-model="send_option.span" label="nomal">通常(推奨)</el-radio>
          <el-tooltip placement="bottom-start">
            <div slot="content">6~8分程度の間隔でメッセージが送信されます。</div>
            <span>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: -5px;" />
            </span>
          </el-tooltip>
        </div>
      </div>
      <div class="divider full"></div>
      <div class="inbox-phrase-popup-title" v-if="activate == 20 && admin_mode">
        DMと同時に投稿にコメント
        <el-tooltip placement="bottom-start">
          <div slot="content">
            DMと同時にインフルエンサーの最新の投稿にコメントを残します。
            <br />このオプションはスパムとみなされる可能性が高くなります。
          </div>
          <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
        </el-tooltip>
        <div class="flex-space"></div>
        <el-switch v-model="send_option.comment"></el-switch>
      </div>
      <div style="color:#aaa; font-size:10px" v-if="send_option.comment">このオプションはスパムとみなされる可能性が高くなります。</div>
      <div v-show="send_option.comment" style="margin-top:10px">
        <el-input v-model="send_option.comment_text" type="textarea" :rows="6" placeholder="投稿に残すコメント文を入力してください" resize="none" maxlength="100" show-word-limit></el-input>
        <div style="color:#aaa; font-size:8px; margin-top:5px">
          コメントを残すためにユーザーのフォローも同時に行います。コメントが制限されている場合、コメントを残せない可能性もあります。
        </div>
      </div>
      <div class="divider full" v-if="activate == 20 && admin_mode"></div>
      <div class="inbox-phrase-popup-title">
        送信完了/失敗をメールで通知
        <el-tooltip placement="bottom-start">
          <div slot="content">送信完了時/送信失敗時に登録メールアドレス宛に通知メールを送信します。</div>
          <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
        </el-tooltip>
        <div class="flex-space"></div>
        <el-switch v-model="send_option.mail"></el-switch>
      </div>
      <div class="divider full"></div>
      <div class="inbox-phrase-popup-title">
        送信失敗時に再送信
        <el-tooltip placement="bottom-start">
          <div slot="content">
            いずれかのインフルエンサーへの送信が失敗した際は、失敗以降のインフルエンサーへの送信が停止されます。
            <br />このオプションを利用すると、翌日以降に自動で再送信を行うことができます。
          </div>
          <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
        </el-tooltip>
        <div class="flex-space"></div>
        <el-switch v-model="send_option.ongoing"></el-switch>
      </div>
      <!-- <div style="color:#aaa; font-size:10px">このオプションはスパムとみなされる可能性が高くなります。</div> -->
      <div class="inbox-phrase-popup-radio-wrap column" v-if="send_option.ongoing">
        <!-- <div class="inbox-phrase-popup-radio left">
          <el-radio v-model="send_option.ongoing_type" label="instantly">即座に再送信を続行</el-radio>
          <el-tooltip placement="bottom-start">
            <div slot="content">いずれかのインフルエンサーのメッセージの送信に失敗した場合でも、<br />即座に次のインフルエンサーのメッセージ送信を行います。</div>
            <span>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: -5px;" />
            </span>
          </el-tooltip>
        </div> -->
        <div class="inbox-phrase-popup-radio">
          <el-radio v-model="send_option.ongoing_type" label="later">翌日以降に再送信を続行</el-radio>
          <el-tooltip placement="bottom-start">
            <div slot="content">いずれかのインフルエンサーのメッセージの送信に失敗した場合、<br />設定した日時にメッセージの再送信を行います。<br />翌日以降から7日後までの間で日時指定できます。</div>
            <span>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: -5px;" />
            </span>
          </el-tooltip>
        </div>
        <div class="input-phrase-popup-numinput">
          <el-date-picker
            v-model="send_option.ongoing_date"
            type="date"
            :disabled="send_option.ongoing_type == 'instantly'"
            placeholder="再送信日"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            :picker-options="pickerOptions"
            :default-value="default_date"
            size="mini"
            style="margin-right:10px"
            :clearable="false"
          ></el-date-picker>
          <el-time-select
            align="center"
            size="mini"
            :disabled="send_option.ongoing_type == 'instantly'"
            placeholder="再送信時間"
            v-model="send_option.ongoing_time"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
            }"
            :clearable="false"
          ></el-time-select>
        </div>
      </div>
      <div class="divider full"></div>
      <div class="inbox-phrase-popup-title">
        メッセージ送信可能時間
        <el-tooltip placement="bottom-start">
          <div slot="content">指定した時間外になると送信が自動で停止され、指定した時間内になると再度送信を再開します。<br /></div>
          <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
        </el-tooltip>
        <div class="flex-space"></div>
        <el-switch v-model="send_option.sendable_time_switch"></el-switch>
      </div>
      <div style="color:#aaa; font-size:8px; margin-bottom:10px;">以下の時間帯でのみ送信を実行する</div>
      <div class="inbox-phrase-popup-sendabletime" v-if="send_option.sendable_time_switch">
        <el-time-select
          align="center"
          size="mini"
          placeholder="から"
          v-model="send_option.sendable_time_start"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
            maxTime: send_option.sendable_time_end,
          }"
          :clearable="false"
        ></el-time-select>
        <span style="margin:0 10px">~</span>
        <el-time-select
          align="center"
          size="mini"
          placeholder="まで"
          v-model="send_option.sendable_time_end"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
            minTime: send_option.sendable_time_start,
          }"
          :clearable="false"
        ></el-time-select>
      </div>
      <div class="inbox-phrase-popup-sendabletime" v-else>
        <el-time-select align="center" size="mini" disabled></el-time-select>
        <span style="margin:0 10px">~</span>
        <el-time-select align="center" size="mini" disabled></el-time-select>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "messageOption",
  props: ["option_modal", "referrer"],
  data() {
    return {};
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    send_option() {
      return this.$store.state.send_option;
    },
    default_date() {
      var defaultDate = new Date();
      defaultDate.setDate(defaultDate.getDate() + 1);
      return defaultDate;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          var start = new Date();
          var end = new Date();
          end.setDate(end.getDate() + 7);
          return start > time.getTime() || time.getTime() > end;
        },
      };
    },
  },
  mounted() {
    this.changeDefaultDate();
    if (this.send_option.ongoing_type == "instantly") {
      this.send_option.ongoing_type = "later";
    }
  },
  methods: {
    changeDefaultDate() {
      var year = this.default_date.getFullYear();
      var month = this.default_date.getMonth() + 1;
      var date = this.default_date.getDate();
      this.send_option.ongoing_date = year + "/" + month + "/" + date;
    },
    speedyAlert() {
      if (this.send_option.span == "speedy") {
        this.$confirm(
          "やりとりを行ったことがない新規インフルエンサー対してDMを送信する場合、送信間隔が短すぎるとスパムとみなされる可能性が高まり、DM規制がかかりやすくなります。<br>" +
            "スピーディに設定する場合、既にやりとりを行っているインフルエンサーに対するDMのみにしていただくことを推奨いたします。",
          "スピーディに設定するとDM規制リスクが高まります。",
          {
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        )
          .then(() => {})
          .catch(() => {
            this.send_option.span = "nomal";
          });
      }
    },
  },
  watch: {
    option_modal() {
      if (this.send_option.sendable_time_start == null) {
        this.send_option.sendable_time_start = "00:00";
      }
      if (this.send_option.sendable_time_end == null) {
        this.send_option.sendable_time_end = "24:00";
      }
      if (this.send_option.ongoing_time == null) {
        this.send_option.ongoing_time = "10:00";
      }
      if (this.send_option.ongoing_date == null) {
        this.changeDefaultDate();
      }
      if (this.option_modal == false) {
        this.$emit("update:option_modal", false);
      }
    },
    send_option: {
      handler() {
        if (this.referrer == "newmessage") {
          this.$store.dispatch("send_option", this.send_option);
        }
      },
      deep: true,
    },
  },
};
</script>
